/**
 * @fileoverview This file contains the Terms section.
 */

/**
 * Terms
 * @returns {JSX.Element} 利用規約の JSX element
 */
export function Terms(): JSX.Element {
return (
	<section className="c-section">
		<h2 className="p-heading-2">利用規約</h2>
		<p className="c-text">
			GasLogReader利用規約<br />
			この規約は、お客様が、株式会社ガステック（以下「当社」）が提供するロギングデータ読み取りソフトウェア「GasLogReader」（以下「本ソフト」）をご利用頂く際の取り扱いにつき定めるものです。本規約に同意した上で本ソフトをご利用ください。
			
			<h3 className="p-heading-3">第1条（定義）</h3>
			本規約上で使用する用語の定義は、次の各号に掲げる通りとします。<br /><br />
			用語：定義<br />
			① 本ソフト：当社が作成したソフトウェアGasLogReader<br />
			② 本コンテンツ: 本ソフト上で提供される文字、音、静止画、動画、ソフトウェアプログラム、コード等の総称<br />
			③ 利用者: 本ソフトを利用する全ての方<br />
			④ 個人情報: 住所、氏名、職業、電話番号等生存する個人を特定することのできる情報の総称<br />
			⑤ 知的財産: 発明、考案、意匠、著作物その他の人間の創造的活動により生み出されるもの（発見または解明がされた自然の法則または現象であって、産業上の利用可能性があるものを含む）、商標、商号その他事業活動に用いられる商品または役務を表示するもの及び営業秘密その他の事業活動に有用な技術上または営業上の情報<br />
			⑥ 知的財産権: 特許権、実用新案権、意匠権、著作権、商標権その他の知的財産に関して法令により定められた権利または法律上保護される利益に係る権利
			
			<h3 className="p-heading-3">第2条（利用契約の成立）</h3>
			1 利用者は、本利用規約に同意頂いた上で、本ソフトを利用できるものとします。<br />
			2 利用者が、パソコンにおいて本ソフトを起動し、本規約への同意手続を行った時点で、利用者と当社との間で、本規約の諸規定に従った利用契約が成立するものとします。<br />
			
			<h3 className="p-heading-3">第3条（知的財産権の取り扱い）</h3>
			利用者は、本ソフト及び本コンテンツが当社の知的財産であり、これらに関する知的財産権が当社に帰属することを認め、これらを一切侵害してはならないものとします。
			
			<h3 className="p-heading-3">第4条（個人情報の取り扱い）</h3>
			個人情報については、当社が別途定める「プライバシーポリシー」に則り、適正に取り扱うこととします。
			
			<h3 className="p-heading-3">第5条（本ソフトの変更等）</h3>
			当社は、いつでも予告なく本ソフトの内容、仕様の変更その他バージョンアップ（以下「本ソフトの変更等」といいます）を行うことができるものとします。

			<h3 className="p-heading-3">第6条（禁止行為）</h3>
			本ソフトの利用に際し、当社は、利用者に対し、次の各号に掲げる行為を禁止します。当社において、利用者が禁止事項に違反したと認めた場合、利用の停止、利用契約の解除、損害の賠償請求その他当社が必要と判断した措置を取ることができます。<br />
			① 当社または第三者の知的財産権を侵害する行為<br />
			② 当社の承諾なく、本コンテンツを複製、改変、解析をする行為<br />
			③ 本ソフトを当社の承諾なく自己の名義で第三者に提供する行為<br />
			④ 当社または第三者の名誉・信用を毀損または不当に差別もしくは誹謗中傷する行為<br />
			⑤ 当社または第三者の財産を侵害する行為、または侵害する恐れのある行為<br />
			⑥ 当社または第三者に経済的損害を与える行為<br />
			⑦ 当社または第三者に対する脅迫的な行為<br />
			⑧ コンピューターウィルス、有害なプログラムを使用し、またはそれを誘発する行為<br />
			⑨ 上記の他、当社が不適切と判断する行為<br />

			<h3 className="p-heading-3">第7条（免責）</h3>
			1.	本ソフトが第5条の規定に基づき変更した場合でも、当社は、これによって生じたいかなる損害についても、一切責任を負いません。<br />
			2.	当社は、利用者の本ソフトの利用環境について一切関与せず、また一切の責任を負いません。<br />
			3.	当社は、本ソフトが利用者の特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、利用者による本ソフトの利用が利用者に適用のある法令または業界団体の内部規則等に適合すること、および不具合が生じないことについて、何ら保証するものではありません。<br />
			4.	当社は、本ソフトが全ての情報端末に対応していることを保証するものではなく、本ソフトの利用に供する情報端末のＯＳバージョンアップ等に伴い、本ソフトの動作に不具合が生じる可能性があることにつき、利用者はあらかじめ了承するものとします。当社は、かかる不具合が生じた場合に当社が行うプログラムの修正等により、当該不具合が解消されることを保証するものではありません。<br />
			5.	当社は、本ソフトが全ての利用環境で動作できることを保証するものではなく、ご利用環境内での電波障害、パソコン内の他アプリによる影響等に伴い、本ソフトの動作に不具合が生じる可能性があることにつき、利用者はあらかじめ了承するものとします。当社は、かかる不具合が生じた場合に当社が行うプログラムの修正等により、当該不具合が解消されることを保証するものではありません。<br />
			6.	利用者は、アプリが動作する情報端末のOSの利用規約および運用方針の変更等に伴い、本サービスの一部又は全部の利用が制限される可能性があることをあらかじめ了承するものとします。<br />
			7.	当社は、本サービスを利用したことにより直接的または間接的に利用者その他の者に発生した損害について、一切賠償責任を負いません。<br />
			8.	当社は、利用者その他の第三者に発生した機会逸失、業務の中断その他いかなる損害（間接損害や逸失利益を含みます）に対して、当社が係る損害の可能性を事前に通知されていたとしても、一切の責任を負いません。<br />
			9.	当社の責任は、その性質を問わず、当社の故意または重過失によらない場合には免責されるものとします。<br />
			10.	前項の定めにかかわらず、本利用契約が消費者契約法に定める消費者契約に該当する場合、当社は、当社の故意または重過失に起因する場合を除き、逸失利益その他の特別の事情によって生じた損害を賠償する責任を負わず、通常生じうる損害の範囲内で、かつ、当該損害が発生した月に利用者から受領した利用額を限度として賠償責任を負うものとします。利用料を受領しないサービスの場合には賠償責任を負う必要はないものとします。<br />
			11.	利用者と他の利用者との間の紛争及びトラブルについて、当社は一切責任を負わないものとします。利用者と他の利用者との間でトラブルになった場合でも、両者の責任で解決するものとし、当社には一切の請求をしないものとします。<br />
			12.	利用者は、本ソフトの利用に関連し、他の利用者に損害を与えた場合または第三者との間に紛争を生じた場合、自己の費用と責任において、損害の賠償または紛争の解決をするものとし、当社には一切の迷惑や損害を与えないものとします。<br />
			13.	利用者の行為により、当社が第三者から損害賠償等の請求をされた場合には、利用者の費用（弁護士費用を含む）と責任で、これを解決するものとします。当社が、当該第三者に対して、損害賠償金を支払った場合には、利用者は、当社に対して当該損害賠償金を含む一切の費用（弁護士費用及び逸失利益を含む）を支払うものとします。<br />
			14.	利用者が本ソフトの利用に関連して当社に損害を与えた場合、利用者の費用と責任において当社に対して損害を賠償（訴訟費用及び弁護士費用を含む）するものとします。
			
			<h3 className="p-heading-3">第8条（権利譲渡の禁止）</h3>
			1.	利用者は、予め当社の書面による承諾がない限り、利用契約上の地位および本規約に基づく権利または義務の全部または一部を第三者に譲渡してはならないものとします。<br />
			2.	当社は、本ソフトの全部または一部を当社の裁量により第三者に譲渡することができ、その場合、譲渡された権利の範囲内で本ソフトに係る利用者の一切の権利が譲渡先に移転するものとします。<br />
			3.	当社は、当社の判断により、本ソフトの全部または一部を第三者に委託することができます。この場合、委託された業務の範囲内で、当該委託先に利用者情報を提供することができ、利用者はあらかじめこれを同意したものとします。
			
			<h3 className="p-heading-3">第9条（分離可能性）</h3>
			本規約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効又は執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。
			
			<h3 className="p-heading-3">第10条（当社への連絡方法）</h3>
			本ソフトに関する利用者の当社へのご連絡・お問い合わせは、当社が運営するwebサイト内の適宜の場所に設置するお問い合わせフォームからの送信または当社が別途指定する方法により行うものとします。
			
			<h3 className="p-heading-3">第11条（準拠法、管轄裁判所）</h3>
			1.	本規約の有効性，解釈及び履行については，日本法に準拠し，日本法に従って解釈されるものとします。<br />
			2.　当社と利用者等との間での本ソフトに関して訴訟の必要が生じたときは、東京地方裁判所を専属的合意管轄裁判所とします｡<br /><br /><br />

			2024年12月23日 施行
		</p>
	</section>
);}